import moment from 'moment';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
import language from '../../../../../assets/languages/language';
import { showFailure } from '../../../../../common/toast';
import FD from '../../../../RestAPI/fetchData';
import App_data from '../../../../config/App_data';
/* eslint-disable*/
class Frm1Quizzes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      chapters: '',
      chapters1: '',
      all_checked_state: true,
      all_checked_state1: true,

      radio_checked_question: 0,
      radio_checked_question1: 0,

      radio_checked_priority: 'none',
      radio_checked_priority1: 'none1',

      single_clicked_val: '',
      single_clicked_val1: '',

      getallabondQuiz: '',
      getallabondQuiz1: '',

      getallcompleteQuiz: '',
      getallcompleteQuiz1: '',

      quiz_length_state: '',
      quiz_length_state1: '',

      selectedmenufrm: 'frm',
      display_loader: 'show_block',
      level: 1,
      level1: 2,

      deleteItemId: '',
      alert_status: false,
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,

      tooltips: [
        {
          placement: `${language.LC().SELECT_HERE_NUMBER}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().ALL_INCOMPLETE_QUIZ}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().SEE_THE_DETAILS}`,
          text_align: 'left',
        },

        {
          placement: `${language.LC().SELECT_HERE_NUMBER}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().ALL_INCOMPLETE_QUIZ}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().SEE_THE_DETAILS}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().Priority_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().unanswered_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().wronganswered_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().Priority_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().unanswered_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().wronganswered_selected}`,
          text_align: 'left',
        },
      ],
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };
  FRM1 = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      exam_choose: 'frm1',
    };
    FD.callAPI(App_data.backend_api + '/frm_question_bank/getChapters', data).then(resp => {
      if (resp.success) {
        var chapters_1_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.chapters.length; i++) {
          if (resp.chapters[i].level == 1) {
            chapters_1_arr[first_incr] = resp.chapters[i];
            first_incr++;
          }
        }
        this.setState({ ValidToken: true, chapters: chapters_1_arr });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/frm_quizes/getallQuizbyPlan', data).then(resp => {
      if (resp.success) {
        var getallabondQuiz = [];
        var completed_quiz = [];
        var dataString = JSON.stringify(resp.getallQuiz);
        var dataReason = JSON.parse(dataString);
        // console.log(dataReason.length+'-----sdf-----');
        if (!dataReason.length) {
          this.setState({ display_loader: 'hide_block' });
        }
        for (var i = 0; i < dataReason.length; i++) {
          if (dataReason[i].count_tot == dataReason[i].number_questions) {
            completed_quiz.push(dataReason[i]);
          } else {
            getallabondQuiz.push(dataReason[i]);
          }
          if (i == dataReason.length - 1) {
            this.setState({ display_loader: 'hide_block' });
          }
          //console.log(dataReason.length+'----------');
        }
        this.setState({
          getallabondQuiz: getallabondQuiz,
          getallcompleteQuiz: completed_quiz,
        });
      } else {
        this.setState({ display_loader: 'hide_block' });
        showFailure(resp.message);
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/frm_quizes/getallQuiz_length', data).then(
      resp_quiz_length => {
        if (resp_quiz_length.success) {
          this.setState({ quiz_length_state: resp_quiz_length.quiz_length });
        } else {
          this.setState({ display_loader: 'hide_block' });
          showFailure(resp.message);
        }
      },
    );
  };

  FRM2 = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      exam_choose: 'frm2',
    };
    FD.callAPI(App_data.backend_api + '/frm_question_bank/getChapters', data).then(resp => {
      if (resp.success) {
        var chapters_1_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.chapters.length; i++) {
          if (resp.chapters[i].level == 2) {
            chapters_1_arr[first_incr] = resp.chapters[i];
            first_incr++;
          }
        }
        this.setState({ ValidToken: true, chapters1: chapters_1_arr });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/frm_quizes/getallQuizbyPlan', data).then(resp => {
      if (resp.success) {
        var getallabondQuiz = [];
        var completed_quiz = [];
        var dataString = JSON.stringify(resp.getallQuiz);
        var dataReason = JSON.parse(dataString);
        if (!dataReason.length) {
          this.setState({ display_loader: 'hide_block' });
        }
        for (var i = 0; i < dataReason.length; i++) {
          if (dataReason[i].count_tot == dataReason[i].number_questions) {
            completed_quiz.push(dataReason[i]);
          } else {
            getallabondQuiz.push(dataReason[i]);
          }
          if (i == dataReason.length - 1) {
            this.setState({ display_loader: 'hide_block' });
          }
          //console.log(dataReason.length+'----------');
        }
        this.setState({
          getallabondQuiz1: getallabondQuiz,
          getallcompleteQuiz1: completed_quiz,
        });
      } else {
        this.setState({ display_loader: 'hide_block' });
        showFailure(resp.message);
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/frm_quizes/getallQuiz_lengthfrm2', data).then(
      resp_quiz_length => {
        if (resp_quiz_length.success) {
          this.setState({ quiz_length_state1: resp_quiz_length.quiz_length });
        } else {
          this.setState({ display_loader: 'hide_block' });
          showFailure(resp.message);
        }
      },
    );
  };
  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (localStorage.getItem('selectedmenu') == 'cfa') {
      this.context.router.push({
        pathname: '/dashboard/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    this.FRM1();
    this.FRM2();
  }

  _all_Checked = () => {
    var checkboxes = document.getElementsByName('approve[]');
    var all_Checked = document.getElementById('all_Checked');
    if (all_Checked.checked) {
      this.setState({ all_checked_state: true }, function all_checked_state() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = '';
        }
      });
    } else {
      this.setState({ all_checked_state: false }, function all_checked_state() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = 'FALSE';
        }
      });
    }
  };
  _all_Checked1 = () => {
    var checkboxes = document.getElementsByName('approve1[]');
    var all_Checked = document.getElementById('all_Checked1');
    if (all_Checked.checked) {
      this.setState({ all_checked_state1: true }, function all_checked_state1() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = '';
        }
      });
    } else {
      this.setState({ all_checked_state1: false }, function all_checked_state1() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = 'FALSE';
        }
      });
    }
  };

  _single_Checked = () => {
    var checkboxes = document.getElementsByName('approve[]');

    var i = 0;
    var single_clicked_value = [];
    for (i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        //console.log(i+'----------'+checkboxes[i].value);
        single_clicked_value.push(checkboxes[i].value);
      }
    }
    this.setState({
      all_checked_state: false,
      single_clicked_val: single_clicked_value,
    });
  };
  _single_Checked1 = () => {
    var checkboxes = document.getElementsByName('approve1[]');

    var i = 0;
    var single_clicked_value = [];
    for (i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        //console.log(i+'----------'+checkboxes[i].value);
        single_clicked_value.push(checkboxes[i].value);
      }
    }

    this.setState({
      all_checked_state1: false,
      single_clicked_val1: single_clicked_value,
    });
  };

  _createQuiz() {
    this.setState({ display_loader: 'show_block' });
    var question_length_val = document.querySelector('input[name="number_questions"]:checked')
      .value;
    var timer_value,
      chapterAll = '';
    timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
    if (this.state.all_checked_state) {
      var dataString = JSON.stringify(this.state.chapters);
      var dataReason = JSON.parse(dataString);
      var chapterall_id = [];
      for (var i = 0; i < dataReason.length; i++) {
        chapterall_id.push(dataReason[i].chapter_no);
      }
      chapterAll = chapterall_id;
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        chapterAll: chapterAll,
        questionquize: question_length_val,
        priority: this.state.radio_checked_priority,
      };
      //console.log(data);
      FD.callAPI(App_data.backend_api + '/frm_quizes/getQuizequestion', data).then(resp => {
        if (resp.success) {
          var retun_all_chapter = JSON.stringify(resp.chapters);
          var chapterParse = JSON.parse(retun_all_chapter);
          var question_id = [];
          var myJson = { question_count: '', all_questions: {} };
          for (var i = 0; i < chapterParse.length; i++) {
            var objName = 'q' + i;
            var objValue = chapterParse[i].id;
            myJson.all_questions[i] = objValue;
            question_id.push(chapterParse[i].id);
          }
          myJson.question_count = question_id.length;
          var questions = JSON.stringify(myJson);
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            number_questions: myJson.question_count,
            questions: questions,
            timer_value: timer_value,
            exam_choose: 'frm1',
            level: this.state.level,
          };
          FD.callAPI(App_data.backend_api + '/frm_quizes/createQuiz', data).then(resp => {
            if (resp.success) {
              this.setState({ display_loader: 'hide_block' });
              this.context.router.push({
                pathname: `/frm/1/beforestart/${resp.last_id}/${this.state.selectedmenufrm}/${''}`,
                state: {
                  token: this.state.token,
                  idname: this.state.idname,
                  quiz_id: resp.last_id,
                  status_send: '',
                  selectedMenu: this.state.selectedmenufrm,
                },
              });
            } else {
              //console.log(resp.success);
            }
          });
        } else {
          this.setState({ display_loader: 'hide_block' });
          showFailure(resp.message);
        }
        return resp;
      });
    } else {
      var checkboxes = document.getElementsByName('approve[]');
      var i = 0;
      var single_clicked_value = [];
      if (this.state.single_clicked_val == '') {
        for (i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].checked) {
            single_clicked_value.push(checkboxes[i].value);
          }
        }
        chapterAll = single_clicked_value;
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapterAll: chapterAll,
          questionquize: question_length_val,
          priority: this.state.radio_checked_priority,
        };
        FD.callAPI(App_data.backend_api + '/frm_quizes/getQuizequestion', data).then(resp => {
          if (resp.success) {
            var retun_all_chapter = JSON.stringify(resp.chapters);
            var chapterParse = JSON.parse(retun_all_chapter);
            var question_id = [];
            var myJson = { question_count: '', all_questions: {} };
            for (var i = 0; i < chapterParse.length; i++) {
              var objName = 'q' + i;
              var objValue = chapterParse[i].id;
              myJson.all_questions[i] = objValue;
              question_id.push(chapterParse[i].id);
            }
            myJson.question_count = question_id.length;
            var questions = JSON.stringify(myJson);
            var data_insert = {
              token: this.state.token,
              idname: this.state.idname,
              number_questions: myJson.question_count,
              questions: questions,
              timer_value: timer_value,
              exam_choose: 'frm1',
              level: this.state.level,
            };

            FD.callAPI(App_data.backend_api + '/frm_quizes/createQuiz', data_insert).then(resp => {
              if (resp.success) {
                this.context.router.push({
                  pathname: `/frm/1/beforestart/${resp.last_id}/${this.state.selectedmenufrm
                    }/${''}`,
                  state: {
                    token: this.state.token,
                    idname: this.state.idname,
                    quiz_id: resp.last_id,
                    selectedMenu: this.state.selectedmenufrm,
                  },
                });
              } else {
                //console.log(resp.success);
              }
            });
          } else {
            this.setState({ display_loader: 'hide_block' });
            showFailure(resp.message);
          }
          return resp;
        });
      } else {
        chapterAll = this.state.single_clicked_val;
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapterAll: chapterAll,
          questionquize: question_length_val,
          priority: this.state.radio_checked_priority,
        };
        FD.callAPI(App_data.backend_api + '/frm_quizes/getQuizequestion', data).then(resp => {
          if (resp.success) {
            var retun_all_chapter = JSON.stringify(resp.chapters);
            var chapterParse = JSON.parse(retun_all_chapter);
            var question_id = [];
            var myJson = { question_count: '', all_questions: {} };
            for (var i = 0; i < chapterParse.length; i++) {
              var objName = 'q' + i;
              var objValue = chapterParse[i].id;
              myJson.all_questions[i] = objValue;
              question_id.push(chapterParse[i].id);
            }
            myJson.question_count = question_id.length;
            var questions = JSON.stringify(myJson);
            var data_insert = {
              token: this.state.token,
              idname: this.state.idname,
              number_questions: myJson.question_count,
              questions: questions,
              timer_value: timer_value,
              exam_choose: 'frm1',
              level: this.state.level,
            };
            FD.callAPI(App_data.backend_api + '/frm_quizes/createQuiz', data_insert).then(resp => {
              if (resp.success) {
                this.context.router.push({
                  pathname: `/frm/1/beforestart/${resp.last_id}/${this.state.selectedmenufrm
                    }/${''}`,
                  state: {
                    token: this.state.token,
                    idname: this.state.idname,
                    quiz_id: resp.last_id,
                    selectedMenu: this.state.selectedmenufrm,
                  },
                });
              } else {
                //console.log(resp.success);
              }
            });
          } else {
            this.setState({ display_loader: 'hide_block' });
            showFailure(resp.message);
          }
          return resp;
        });
      }
    }
  }

  _createQuiz1() {
    this.setState({ display_loader: 'show_block' });
    var question_length_val = document.querySelector('input[name="number_questions1"]:checked')
      .value;
    var timer_value,
      chapterAll = '';
    timer_value = this.state.quiz_length_state1[this.state.radio_checked_question1].timer_value;
    if (this.state.all_checked_state1) {
      var dataString = JSON.stringify(this.state.chapters1);
      var dataReason = JSON.parse(dataString);
      var chapterall_id = [];
      for (var i = 0; i < dataReason.length; i++) {
        chapterall_id.push(dataReason[i].chapter_no);
      }
      chapterAll = chapterall_id;
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        chapterAll: chapterAll,
        questionquize: question_length_val,
        priority: this.state.radio_checked_priority1,
      };
      FD.callAPI(App_data.backend_api + '/frm_quizes/getQuizequestion', data).then(resp => {
        if (resp.success) {
          var retun_all_chapter = JSON.stringify(resp.chapters);
          var chapterParse = JSON.parse(retun_all_chapter);
          var question_id = [];
          var myJson = { question_count: '', all_questions: {} };
          for (var i = 0; i < chapterParse.length; i++) {
            var objName = 'q' + i;
            var objValue = chapterParse[i].id;
            myJson.all_questions[i] = objValue;
            question_id.push(chapterParse[i].id);
          }
          myJson.question_count = question_id.length;
          var questions = JSON.stringify(myJson);
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            number_questions: myJson.question_count,
            questions: questions,
            timer_value: timer_value,
            exam_choose: 'frm2',
            level: this.state.level1,
          };
          FD.callAPI(App_data.backend_api + '/frm_quizes/createQuiz', data).then(resp => {
            if (resp.success) {
              this.setState({ display_loader: 'hide_block' });
              this.context.router.push({
                pathname: `/frm/2/beforestart/${resp.last_id}/${this.state.selectedmenufrm}`,
                state: {
                  token: this.state.token,
                  idname: this.state.idname,
                  quiz_id: resp.last_id,
                  status_send: '',
                  selectedMenu: this.state.selectedmenufrm,
                },
              });
            } else {
              //console.log(resp.success);
            }
          });
        } else {
          this.setState({ display_loader: 'hide_block' });
          showFailure(resp.message);
        }
        return resp;
      });
    } else {
      var checkboxes = document.getElementsByName('approve1[]');
      var i = 0;
      var single_clicked_value = [];
      if (this.state.single_clicked_val == '') {
        for (i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].checked) {
            single_clicked_value.push(checkboxes[i].value);
          }
        }
        chapterAll = single_clicked_value;
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapterAll: chapterAll,
          questionquize: question_length_val,
          priority: this.state.radio_checked_priority1,
        };
        FD.callAPI(App_data.backend_api + '/frm_quizes/getQuizequestion', data).then(resp => {
          if (resp.success) {
            var retun_all_chapter = JSON.stringify(resp.chapters);
            var chapterParse = JSON.parse(retun_all_chapter);
            var question_id = [];
            var myJson = { question_count: '', all_questions: {} };
            for (var i = 0; i < chapterParse.length; i++) {
              var objName = 'q' + i;
              var objValue = chapterParse[i].id;
              myJson.all_questions[i] = objValue;
              question_id.push(chapterParse[i].id);
            }
            myJson.question_count = question_id.length;
            var questions = JSON.stringify(myJson);
            var data_insert = {
              token: this.state.token,
              idname: this.state.idname,
              number_questions: myJson.question_count,
              questions: questions,
              timer_value: timer_value,
              exam_choose: 'frm2',
              level: this.state.level1,
            };

            FD.callAPI(App_data.backend_api + '/frm_quizes/createQuiz', data_insert).then(resp => {
              if (resp.success) {
                this.context.router.push({
                  pathname: `/frm/2/beforestart/${resp.last_id}/${this.state.selectedmenufrm}`,
                  state: {
                    token: this.state.token,
                    idname: this.state.idname,
                    quiz_id: resp.last_id,
                    selectedMenu: this.state.selectedmenufrm,
                  },
                });
              } else {
                //console.log(resp.success);
              }
            });
          } else {
            this.setState({ display_loader: 'hide_block' });
            showFailure(resp.message);
          }
          return resp;
        });
      } else {
        chapterAll = this.state.single_clicked_val1;
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapterAll: chapterAll,
          questionquize: question_length_val,
          priority: this.state.radio_checked_priority1,
        };
        FD.callAPI(App_data.backend_api + '/frm_quizes/getQuizequestion', data).then(resp => {
          if (resp.success) {
            var retun_all_chapter = JSON.stringify(resp.chapters);
            var chapterParse = JSON.parse(retun_all_chapter);
            var question_id = [];
            var myJson = { question_count: '', all_questions: {} };
            for (var i = 0; i < chapterParse.length; i++) {
              var objName = 'q' + i;
              var objValue = chapterParse[i].id;
              myJson.all_questions[i] = objValue;
              question_id.push(chapterParse[i].id);
            }
            myJson.question_count = question_id.length;
            var questions = JSON.stringify(myJson);
            var data_insert = {
              token: this.state.token,
              idname: this.state.idname,
              number_questions: myJson.question_count,
              questions: questions,
              timer_value: timer_value,
              exam_choose: 'frm2',
              level: this.state.level1,
            };
            FD.callAPI(App_data.backend_api + '/frm_quizes/createQuiz', data_insert).then(resp => {
              if (resp.success) {
                this.context.router.push({
                  pathname: `/frm/2/beforestart/${resp.last_id}/${this.state.selectedmenufrm}`,
                  state: {
                    token: this.state.token,
                    idname: this.state.idname,
                    quiz_id: resp.last_id,
                    selectedMenu: this.state.selectedmenufrm,
                  },
                });
              } else {
                //console.log(resp.success);
              }
            });
          } else {
            this.setState({ display_loader: 'hide_block' });
            showFailure(resp.message);
          }
          return resp;
        });
      }
    }
  }

  _checkAbondon(items, e) {
    this.context.router.push({
      pathname: `/frm/1/beforestart/${items.id}/${this.state.selectedmenufrm}/${'abondon'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: items.id,
        status_send: 'abondon',
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  }

  _checkAbondon1(items, e) {
    this.context.router.push({
      pathname: `/frm/2/beforestart/${items.id}/${this.state.selectedmenufrm}/abondon`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: items.id,
        status_send: 'abondon',
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  }

  _checkCompleted(items, e) {
    this.context.router.push({
      pathname: `/frm/1/beforestart/${items.id}/${this.state.selectedmenufrm}/${'completed'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: items.id,
        status_send: 'completed',
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  }

  _checkCompleted1(items, e) {
    this.context.router.push({
      pathname: `/frm/2/beforestart/${items.id}/${this.state.selectedmenufrm}/completed`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: items.id,
        status_send: 'completed',
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  }
  _length_Checked(items, index_value, e) {
    this.setState({ radio_checked_question: index_value });
  }

  _length_Checked1(items, index_value, e) {
    this.setState({ radio_checked_question1: index_value });
  }
  _priority_selected(e) {
    // console.log("_priority_selected")
    this.setState({ radio_checked_priority: e.target.value });
  }
  _priority_selected1(e) {
    // console.log("_priority_selected1", e.target.value)
    // console.log(e.target.value)
    this.setState({ radio_checked_priority1: e.target.value });
  }

  deleteQuizzes = (items, e) => {
    //console.log("deleteQuizzes", items);
    if (!this.state.alert_status) {
      this.setState({
        deleteItemId: items.id,
        alert_status: true,
      });
    } else {
      this.setState({
        deleteItemId: '',
        alert_status: false,
      });
    }
  };

  deleteToggleDone = async e => {
    //console.log("calllinggg!!!!");
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      deleteItemId: this.state.deleteItemId,
    };
    await FD.callAPI(App_data.backend_api + '/frm_quizes/deleteAbandonedQuizzes', data).then(
      async resp => {
        if (resp.success) {
          await this.FRM1();
          await this.FRM2();
          this.setState({
            deleteItemId: '',
            alert_status: false,
          });
        }
      },
    );
  };

  render() {
    let chapters_all = this.state.chapters;
    let chapters_all1 = this.state.chapters1;

    let chapter_data = '';
    let chapter_data1 = '';

    if (this.state.chapters.length) {
      chapter_data = chapters_all.map((items, index) => (
        <div className='col-md-6' key={index}>
          <label className='check_container'>
            {items.chapter_name}
            <input
              type='checkbox'
              name='approve[]'
              value={items.chapter_no}
              onClick={this._single_Checked.bind(this)}
            />
            <span className='checkmark' />
          </label>
        </div>
      ));
    }
    if (this.state.chapters1.length) {
      chapter_data1 = chapters_all1.map((items, index) => (
        <div className='col-md-6' key={index}>
          <label className='check_container'>
            {items.chapter_name}
            <input
              type='checkbox'
              name='approve1[]'
              value={items.chapter_no}
              onClick={this._single_Checked1.bind(this)}
            />
            <span className='checkmark' />
          </label>
        </div>
      ));
    }

    let abandoned_all = this.state.getallabondQuiz;

    let abandoned_data = '';

    if (this.state.getallabondQuiz.length) {
      abandoned_data = abandoned_all.map((items, index) => (
        <tr key={index}>
          <td className='text_red'>
            <strong>
              {language.LC().ID}: {items.id}
            </strong>
          </td>
          <td>
            {language.LC().QUESTIONS}: {items.number_questions}
          </td>
          <td>
            {language.LC().DATE}: <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkAbondon.bind(this, items)}>
              {language.LC().RECOVER}
            </span>
          </td>
          <td>
            <span className='delete-quizzes' onClick={() => this.deleteQuizzes(items)}>
              {' '}
              <i className='fa fa-trash' aria-hidden='true' /> Delete{' '}
            </span>
          </td>
        </tr>
      ));
    } else {
      abandoned_data = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }
    let abandoned_all1 = this.state.getallabondQuiz1;

    let abandoned_data1 = '';

    if (this.state.getallabondQuiz1.length) {
      abandoned_data1 = abandoned_all1.map((items, index) => (
        <tr key={index}>
          <td className='text_red'>
            <strong>
              {language.LC().ID}: {items.id}
            </strong>
          </td>
          <td>
            {language.LC().QUESTIONS}: {items.number_questions}
          </td>
          <td>
            {language.LC().DATE}: <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkAbondon1.bind(this, items)}>
              {language.LC().RECOVER}
            </span>
          </td>
          <td>
            <span className='delete-quizzes' onClick={() => this.deleteQuizzes(items)}>
              {' '}
              <i className='fa fa-trash' aria-hidden='true' /> Delete{' '}
            </span>
          </td>
        </tr>
      ));
    } else {
      abandoned_data1 = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let getallcompleteQuiz_all = this.state.getallcompleteQuiz;
    let getallcompleteQuiz_data = '';
    if (this.state.getallcompleteQuiz.length) {
      getallcompleteQuiz_data = getallcompleteQuiz_all.map((items, index) => (
        <tr key={index} className='quize-row'>
          <td className='text_green'>
            <strong>
              {language.LC().ID}: {items.id}
            </strong>
          </td>
          <td>
            {language.LC().QUESTIONS} : {items.number_questions}
          </td>
          <td>
            {language.LC().DATE} : <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkCompleted.bind(this, items)}>
              {language.LC().VIEW}
            </span>
          </td>
        </tr>
      ));
    } else {
      getallcompleteQuiz_data = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let getallcompleteQuiz_all1 = this.state.getallcompleteQuiz1;
    let getallcompleteQuiz_data1 = '';
    if (this.state.getallcompleteQuiz1.length) {
      getallcompleteQuiz_data1 = getallcompleteQuiz_all1.map((items, index) => (
        <tr key={index} className='quize-row'>
          <td className='text_green'>
            <strong>Id: {items.id}</strong>
          </td>
          <td>
            {language.LC().QUESTIONS} : {items.number_questions}
          </td>
          <td>
            {language.LC().DATE} : <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkCompleted1.bind(this, items)}>
              {language.LC().VIEW}
            </span>
          </td>
        </tr>
      ));
    } else {
      getallcompleteQuiz_data1 = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let quiz_length_state_all = this.state.quiz_length_state;
    let quiz_length_state_data = '';
    if (this.state.quiz_length_state.length) {
      quiz_length_state_data = quiz_length_state_all.map((items, index) => (
        <label className='radio_container' key={index}>
          {items.quiz_length} {language.LC().QUESTIONS}
          <input
            type='radio'
            id='number_questions_id'
            name='number_questions'
            value={items.quiz_length}
            checked={this.state.radio_checked_question == index}
            onClick={this._length_Checked.bind(this, items, index)}
          />
          <span className='checkmark' />
        </label>
      ));
    }

    let quiz_length_state_all1 = this.state.quiz_length_state1;
    let quiz_length_state_data1 = '';
    if (this.state.quiz_length_state1.length) {
      quiz_length_state_data1 = quiz_length_state_all1.map((items, index) => (
        <label className='radio_container' key={index}>
          {items.quiz_length} {language.LC().QUESTIONS}
          <input
            type='radio'
            id='number_questions_id1'
            name='number_questions1'
            value={items.quiz_length}
            checked={this.state.radio_checked_question1 == index}
            onClick={this._length_Checked1.bind(this, items, index)}
          />
          <span className='checkmark' />
        </label>
      ));
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-md-12 margin_bottom_20'>
              <div className='frm_title_logo_wrap'>
                <h1 className='section_head'>{language.LC().QUIZZES}</h1>
                <img
                  src={App_data.frontend_url + '/img/GARP_logo.png'}
                  className='garpLogo'
                  alt='full logo'
                />
              </div>
              <div className='row frm_quizzes_sub_heading'>
                <div>
                  <h1 className='section_head'>{language.LC().FRM_LEVEL_I_QUIZZES}</h1>
                </div>

                <div className=' text-md-right '>
                  <button
                    className='btn btn-primary pointer_class'
                    onClick={this._createQuiz.bind(this)}
                  >
                    {language.LC().CREATE_QUIZ}
                  </button>
                </div>
              </div>

              <div className='row'>
                <div className='col-lg-7'>
                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().CONTENT}
                      <div className='card-actions float-right'>
                        <label className='check_container margin_bottom_0'>
                          {' '}
                          {language.LC().ALL_CHAPTERS}
                          <input
                            type='checkbox'
                            id='all_Checked'
                            name='all_checked'
                            value='select'
                            onClick={this._all_Checked.bind(this)}
                            checked={this.state.all_checked_state}
                          />
                          <span className='checkmark' />
                        </label>
                      </div>
                    </div>
                    <div className='card-block padding_15'>
                      <div className='row'>{chapter_data}</div>
                    </div>
                  </div>

                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().ABANDONED_QUIZZES}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='1'
                          id='1'
                          content={this.state.tooltips[1].placement}
                          place_tip={this.state.tooltips[1].text_align}
                        />
                      </div>
                    </div>
                    <div className='table_responsive_wrapper abandoned_quizzes_cards_scroll'>
                      <div className='table-responsive'>
                        <table className='table_white_bg table'>
                          <tbody>{abandoned_data}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-5'>
                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().Priorities_By}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='6'
                          id='6'
                          content={this.state.tooltips[6].placement}
                          place_tip={this.state.tooltips[6].text_align}
                        />
                      </div>
                    </div>
                    <div className='card-block'>
                      <label className='radio_container'>
                        {' '}
                        {language.LC().NONE}
                        <input
                          type='radio'
                          id='none'
                          name='none'
                          value='none'
                          checked={this.state.radio_checked_priority == 'none'}
                          onClick={this._priority_selected.bind(this)}
                        />
                        <span className='checkmark' />
                      </label>
                      <label className='radio_container'>
                        {language.LC().UNANSWERED}
                        <input
                          type='radio'
                          id='mark_unanswered'
                          name='mark_unanswered'
                          value='unanswered'
                          checked={this.state.radio_checked_priority == 'unanswered'}
                          onClick={this._priority_selected.bind(this)}
                        />
                        <span className='checkmark' />
                      </label>
                      <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                        <TooltipItem
                          key='7'
                          id='7'
                          content={this.state.tooltips[7].placement}
                          place_tip={this.state.tooltips[7].text_align}
                        />
                      </div>
                      <label className='radio_container'>
                        {' '}
                        {language.LC().Wrong_answers}
                        <input
                          type='radio'
                          id='mark_unattempted'
                          name='mark_unattempted'
                          value='wrongquestion'
                          checked={this.state.radio_checked_priority == 'wrongquestion'}
                          onClick={this._priority_selected.bind(this)}
                        />
                        <span className='checkmark' />
                      </label>
                      <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                        <TooltipItem
                          key='8'
                          id='8'
                          content={this.state.tooltips[8].placement}
                          place_tip={this.state.tooltips[8].text_align}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().LENGTH}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='0'
                          id='0'
                          content={this.state.tooltips[0].placement}
                          place_tip={this.state.tooltips[0].text_align}
                        />
                      </div>
                    </div>
                    <div className='card-block'>
                      {quiz_length_state_data}
                      {/*<div className="checkbox checkbox-info checkbox-circle radio_wrapper">
			                    </div>*/}
                    </div>
                  </div>

                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().COMPLETED_QUIZZES}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='2'
                          id='2'
                          content={this.state.tooltips[2].placement}
                          place_tip={this.state.tooltips[2].text_align}
                        />
                      </div>
                    </div>
                    <div className='table_responsive_wrapper'>
                      <div className='table-responsive'>
                        <table className='table_white_bg table'>
                          <tbody>{getallcompleteQuiz_data}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row frm_quizzes_sub_heading' id={'frm_2'} name='frm_2'>
                {/* <div className="col-md-8 margin_bottom_20" id={"frm_2"}> */}
                <h1 className='section_head'> {language.LC().FRM_LEVEL_II_QUIZZES} </h1>
                {/* </div> */}
                <div className='text-md-right'>
                  <button
                    className='btn btn-primary pointer_class'
                    onClick={this._createQuiz1.bind(this)}
                  >
                    {' '}
                    {language.LC().CREATE_QUIZ}{' '}
                  </button>
                </div>
              </div>

              <div className='row'>
                <div className='col-lg-7'>
                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().CONTENT}
                      <div className='card-actions float-right'>
                        <label className='check_container margin_bottom_0'>
                          {language.LC().ALL_CHAPTERS}
                          <input
                            type='checkbox'
                            id='all_Checked1'
                            name='all_Checked1'
                            value='select'
                            onClick={this._all_Checked1.bind(this)}
                            checked={this.state.all_checked_state1}
                          />
                          <span className='checkmark' />
                        </label>
                      </div>
                    </div>
                    <div className='card-block padding_15'>
                      <div className='row'>{chapter_data1}</div>
                    </div>
                  </div>

                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().ABANDONED_QUIZZES}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='4'
                          id='4'
                          content={this.state.tooltips[4].placement}
                          place_tip={this.state.tooltips[4].text_align}
                        />
                      </div>
                    </div>
                    <div className='table_responsive_wrapper abandoned_quizzes_cards_scroll'>
                      <div className='table-responsive'>
                        <table className='table_white_bg table'>
                          <tbody>{abandoned_data1}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-lg-5'>
                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().Priorities_By}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='9'
                          id='9'
                          content={this.state.tooltips[9].placement}
                          place_tip={this.state.tooltips[9].text_align}
                        />
                      </div>
                    </div>
                    <div className='card-block'>
                      <label className='radio_container'>
                        {' '}
                        {language.LC().NONE}
                        <input
                          type='radio'
                          id='none1'
                          name='none1'
                          value='none1'
                          checked={this.state.radio_checked_priority1 == 'none1'}
                          onClick={this._priority_selected1.bind(this)}
                        />
                        <span className='checkmark' />
                      </label>
                      <label className='radio_container'>
                        {language.LC().UNANSWERED}
                        <input
                          type='radio'
                          id='mark_unanswered'
                          name='mark_unanswered'
                          value='unanswered'
                          checked={this.state.radio_checked_priority1 == 'unanswered'}
                          onClick={this._priority_selected1.bind(this)}
                        />
                        <span className='checkmark' />
                      </label>
                      <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                        <TooltipItem
                          key='10'
                          id='10'
                          content={this.state.tooltips[10].placement}
                          place_tip={this.state.tooltips[10].text_align}
                        />
                      </div>
                      <label className='radio_container'>
                        {' '}
                        {language.LC().Wrong_answers}
                        <input
                          type='radio'
                          id='mark_unattempted'
                          name='mark_unattempted'
                          value='wrongquestion'
                          checked={this.state.radio_checked_priority1 == 'wrongquestion'}
                          onClick={this._priority_selected1.bind(this)}
                        />
                        <span className='checkmark' />
                      </label>
                      <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                        <TooltipItem
                          key='11'
                          id='11'
                          content={this.state.tooltips[11].placement}
                          place_tip={this.state.tooltips[11].text_align}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().LENGTH}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='3'
                          id='3'
                          content={this.state.tooltips[3].placement}
                          place_tip={this.state.tooltips[3].text_align}
                        />
                      </div>
                    </div>
                    <div className='card-block'>
                      {quiz_length_state_data1}
                      {/*<div className="checkbox checkbox-info checkbox-circle radio_wrapper">
			                    </div>*/}
                    </div>
                  </div>

                  <div className='card'>
                    <div className='card-header'>
                      {language.LC().COMPLETED_QUIZZES}
                      <div className='card-actions card_action_tooltip float-right'>
                        <TooltipItem
                          key='5'
                          id='5'
                          content={this.state.tooltips[5].placement}
                          place_tip={this.state.tooltips[5].text_align}
                        />
                      </div>
                    </div>
                    <div className='table_responsive_wrapper'>
                      <div className='table-responsive'>
                        <table className='table_white_bg table'>
                          {/*<thead>    											
											<tr>
								                <th></th>
								                <th></th>
								                <th></th>
								                <th></th>
											</tr>
										</thead>*/}
                          <tbody>{getallcompleteQuiz_data1}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            isOpen={this.state.alert_status}
            toggle={this.deleteQuizzes}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.deleteQuizzes}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.deleteToggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>

        {
          <div className={'loader_box ' + this.state.display_loader}>
            <div className='sk-circle'>
              <div className='sk-circle1 sk-child' />
              <div className='sk-circle2 sk-child' />
              <div className='sk-circle3 sk-child' />
              <div className='sk-circle4 sk-child' />
              <div className='sk-circle5 sk-child' />
              <div className='sk-circle6 sk-child' />
              <div className='sk-circle7 sk-child' />
              <div className='sk-circle8 sk-child' />
              <div className='sk-circle9 sk-child' />
              <div className='sk-circle10 sk-child' />
              <div className='sk-circle11 sk-child' />
              <div className='sk-circle12 sk-child' />
            </div>
          </div>
        }
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    // console.log("TooltipItem",props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          alt=''
          className=''
          width='18'
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

function Dateform(props) {
  var myDate = moment(props.created_d).format('YYYY-MM-DD');
  return <span>{myDate}</span>;
}

export default Frm1Quizzes;



// WEBPACK FOOTER //
// ./src/views/FRM/Frm1Quizzes/part-1/Frm1Quizzes/Frm1Quizzes.js